import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import { appTranslate } from '../../../i18n';
import { STANDALONE_ONBOARDING_IMAGE } from './constants';

export const OnboardingBanner = () => (
    <Container position="relative" height="100%" maxHeight="100%">
        <Image
            borderRadius="2xl"
            alt={appTranslate<string>('identification.banner.image_alt')}
            objectFit="cover"
            height="100%"
            maxWidth="100%"
            maxHeight="100%"
            width="auto"
            src={STANDALONE_ONBOARDING_IMAGE}
            htmlWidth="480"
            htmlHeight="711"
        />
    </Container>
);
